import { DateTime } from 'luxon'

import { AnyProfile, CompanyHistoryProfile } from '@modules/search/types'

export const getFieldIsUpdated = (data: { fieldName?: string; profileData: AnyProfile; lastViewedAt?: string }) => {
  const { fieldName, profileData, lastViewedAt } = data
  if (!fieldName || !profileData || !lastViewedAt) {
    return false
  }

  const fieldUpdatedAt = profileData[`${fieldName}UpdatedAt` as keyof AnyProfile]
  if (!fieldUpdatedAt) {
    return false
  }

  const updatedAtDate = DateTime.fromISO(fieldUpdatedAt as string)
  const viewedAtDate = DateTime.fromISO(lastViewedAt)

  return updatedAtDate.toSeconds() > viewedAtDate.toSeconds()
}

export const getDefaultEventByCompanyData = (company: CompanyHistoryProfile): number | undefined => {
  if (company?.latest?.hasAssets && company?.latest?.isPublished) {
    return company?.latest.eventData.id
  }

  const events = [...(company?.events ?? [])]

  events.sort((a, b) =>
    new Date(a.profileCreatedAt).getMilliseconds() > new Date(b.profileCreatedAt).getMilliseconds() ? 1 : -1,
  )

  return events[0]?.id
}
